// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store/index'  //引入
// import FastClick from 'fastclick'



// 引入swiper样式
import 'swiper/css/swiper.css'
import "@/assets/base.js";

//引封装的方法
import instance from "./api/methods"
Vue.prototype.$api=instance
//引封装的路径
import path from "./api/path"
Vue.prototype.$path=path

Vue.use(VueAxios, axios)
Vue.prototype.$axios = axios
// Vue.prototype.$httpApi = "http://59.110.161.46:8082"   //请求域名
Vue.prototype.$httpApi = "http://www.amazingray.cn"   //请求域名



Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,    
  router,
  components: { App },
  template: '<App/>'
})

/* FastClick.prototype.focus = function (targetElement) {
  let length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
}; */



// WEBPACK FOOTER //
// ./src/main.js